import { posts } from "assets/data/posts";
import { FeedPost } from "components";
import ReportPostsLayout from "layouts/ReportPostsLayout";

const IllegalReports = () => {
    return (
        <ReportPostsLayout
            breadCrumbTitle="Illegal and Urgent"
            title="Illegal and Urgent Posts Reports"
        >
            <>
                {posts.slice(5, 7).map((i) => (
                    <FeedPost post={i} key={i.id} />
                ))}
            </>
        </ReportPostsLayout>
    );
};

export default IllegalReports;
